const userActions = {
  FETCH_DEVICE_ALARM_SETTING: 'FETCH_DEVICE_ALARM_SETTING',
  FETCH_DEVICE_ALARM_SETTING_SUCCESS: 'FETCH_DEVICE_ALARM_SETTING_SUCCESS',
  FETCH_DEVICE_ALARM_SETTING_ERROR: 'FETCH_DEVICE_ALARM_SETTING_ERROR',
  UPDATE_DEVICE_ALARM_SETTING: 'UPDATE_DEVICE_ALARM_SETTING',
  UPDATE_DEVICE_ALARM_SETTING_SUCCESS: 'UPDATE_DEVICE_ALARM_SETTING_SUCCESS',
  UPDATE_DEVICE_ALARM_SETTING_ERROR: 'UPDATE_DEVICE_ALARM_SETTING_ERROR',
  UPDATE_DEVICE_ALARM_SETTING_RESET_STATE:
    'UPDATE_DEVICE_ALARM_SETTING_RESET_STATE',
  UPDATE_IS_SNOOZE_EXPIRED: 'UPDATE_IS_SNOOZE_EXPIRED', //isSnoozeExpired

  //
  GET_USER_PROFILE: 'GET_USER_PROFILE',
  GET_USER_PROFILE_SUCCESS: 'GET_USER_PROFILE_SUCCESS',
  GET_USER_PROFILE_ERROR: 'GET_USER_PROFILE_ERROR',
};
const updateSnoozeExpiredState = (payload) => ({
  type: userActions.UPDATE_IS_SNOOZE_EXPIRED,
  payload,
});

const fetchDeviceAlarmSettings = () => ({
  type: userActions.FETCH_DEVICE_ALARM_SETTING,
});
const fetchDeviceAlarmSettingsSuccess = (payload) => ({
  type: userActions.FETCH_DEVICE_ALARM_SETTING_SUCCESS,
  payload,
});
const fetchDeviceAlarmSettingsError = () => ({
  type: userActions.FETCH_DEVICE_ALARM_SETTING_ERROR,
});

const updateDeviceAlarmSettings = (data) => ({
  type: userActions.UPDATE_DEVICE_ALARM_SETTING,
  payload: data,
});
const updateDeviceAlarmSettingsSuccess = (payload) => ({
  type: userActions.UPDATE_DEVICE_ALARM_SETTING_SUCCESS,
  payload,
});
const updateDeviceAlarmSettingsError = () => ({
  type: userActions.UPDATE_DEVICE_ALARM_SETTING_ERROR,
});

const updateDeviceAlarmSettingsResetState = () => ({
  type: userActions.UPDATE_DEVICE_ALARM_SETTING_RESET_STATE,
});

export const getUserProfile = (params, callback = () => {}) => ({
  type: userActions.GET_USER_PROFILE,
  payload: params,
  callback,
});

export {
  fetchDeviceAlarmSettings,
  fetchDeviceAlarmSettingsError,
  fetchDeviceAlarmSettingsSuccess,
  updateDeviceAlarmSettings,
  updateDeviceAlarmSettingsError,
  updateDeviceAlarmSettingsResetState,
  updateDeviceAlarmSettingsSuccess,
  updateSnoozeExpiredState,
  userActions
};

